import { values } from 'lodash';
import { StepType } from '@doltech/ui/lib/figma/Steps/StepsV2';

export const NamedStepEnum = {
  BASIC_INFO: 0,
  INPUT_DATA: 1,
  QUESTION_GROUP: 2,
  LIST_VOCAB: 3,
  ASSIGN_TO: 4,
} as const;

export type NamedStepEnum = (typeof NamedStepEnum)[keyof typeof NamedStepEnum];

export const createBookStepLabels: StepType[] = [
  {
    name: 'Basic info',
    status: 'wait',
  },
  { name: 'Chọn Test', status: 'wait' },
  { name: 'Review & Update', status: 'wait' },
];

export const TOTAL_STEP = values(NamedStepEnum).length;

export const defaultSingleOptions: any = [
  { key: 0, value: '' },
  { key: 1, value: '' },
  { key: 2, value: '' },
];

export const defaultSingleOptionsV2: any = [
  { key: 0, value: '' },
  { key: 1, value: '' },
  { key: 2, value: '' },
  { key: 3, value: '' },
];

export const defaultCorrectAnswer = {
  value: '',
  blankId: '',
};

export const generateCorrectAnswer = (options: any) => ({
  ...defaultCorrectAnswer,
  ...options,
});

export const defaultCorrectAnswers = [
  generateCorrectAnswer({ key: 0 }),
  generateCorrectAnswer({ key: 1 }),
  generateCorrectAnswer({ key: 2 }),
];

export const PASSAGE_TYPE_OPTION = [
  { key: 'PASSAGE1', value: 'Passage 1' },
  { key: 'PASSAGE2', value: 'Passage 2' },
  { key: 'PASSAGE3', value: 'Passage 3' },
];
export const SECTION_TYPE_OPTION = [
  { key: 'SECTION1', value: 'Section 1' },
  { key: 'SECTION2', value: 'Section 2' },
  { key: 'SECTION3', value: 'Section 3' },
  { key: 'SECTION4', value: 'Section 4' },
];

export const VERSION_ENUM = {
  CURRENT_VERSION: 'CURRENT_VERSION',
  OLD_VERSION: 'OLD_VERSION',
};

export const VERSION_TYPE = [
  {
    key: VERSION_ENUM.CURRENT_VERSION,
    value: 'Current version',
  },
  {
    key: VERSION_ENUM.OLD_VERSION,
    value: 'Old version',
  },
];

export const ReadingQuestionTypeDisplayName = {
  // dang select dap an
  TRUE_FALSE_NOT_GIVEN: 'True/ False/ Not Given',
  YES_NO_NOT_GIVEN: 'Yes/ No/ Not Given',
  MULTIPLE_CHOICE: 'Multiple Choice',
  CHOOSE_A_TITLE: 'Choose a Title',
  LIST_SELECTION: 'List Selection',

  // dang drag and drop
  MATCHING_HEADINGS: 'Matching Headings',
  MATCHING_PARAGRAPH_INFORMATION: 'Matching Paragraph Information',
  MATCHING_NAME: 'Matching Name',
  MATCHING_SENTENCE_ENDINGS: 'Matching Sentence Endings',

  // dang gap fill
  SHORT_ANSWER: 'Short Answer',
  SENTENCE_COMPLETION: 'Sentence Completion',
  TABLE_COMPLETION: 'Table Completion',
  SUMMARY_COMPLETION: 'Summary Completion',
  FLOW_CHART_COMPLETION: 'Flow Chart Completion',
  DIAGRAM_COMPLETION: 'Diagram Completion',
};

export type ReadingQuestionTypeDisplayName =
  (typeof ReadingQuestionTypeDisplayName)[keyof typeof ReadingQuestionTypeDisplayName];

export const ListeningQuestionTypeDisplayName = {
  // dang gap fill
  SHORT_ANSWER: 'Short Answer',
  FORM_COMPLETION: 'Form Completion',
  SENTENCE_COMPLETION: 'Sentence Completion',
  TABLE_COMPLETION: 'Table Completion',

  // dang select dap an
  MULTIPLE_CHOICE: 'Multiple Choice',
  PICK_FROM_A_LIST: 'Pick from a list',
  MATCHING_INFORMATION: 'Matching Information',

  // dang drag and drop
  PLAN_MAP_DIAGRAM_LABELING: 'Plan, Map, Diagram Labeling',
};

export type ListeningQuestionTypeDisplayName =
  (typeof ListeningQuestionTypeDisplayName)[keyof typeof ListeningQuestionTypeDisplayName];
